import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import { AddUpdateDeviceParams, DevicesInfoData, MiniCardParams, MiniCardWithoutPackParams } from '../models/devices';
import {CryptoService} from './crypto.service';

@Injectable({
  providedIn: 'root'
})
export class DevicesService {

  constructor(private http: HttpClient, private cryptoService: CryptoService) { }

  getDevicesStatus(params): Observable <any> {
    return this.http.post<any>(`${environment.apiIotUrl}/device/read/status`, params);
  }
  getDevicesInfo(params): Observable <any> {
    if (typeof params === 'string') {
      return this.http.post<any>
      (`${environment.apiSerivceUrl}/Personal/api/Service/ReadDeviceInforByAccount`,
        {otp: params}, { headers: new HttpHeaders({ 'Content-Type': 'application/json' })});
    } else {
      return this.http.post<any>
      (`${environment.apiSerivceUrl}/device/read/account`,
        params, { headers: new HttpHeaders({ 'Content-Type': 'application/json' })});
    }
  }
  getDeviceDetails(params): Observable <any> {
     return this.http.post<any>(`${environment.apiIotUrl}/device/read/details`, params);
    // return this.http.get<any>(`${environment.apiIotUrl}/status?sn=${sn}&otp=${otp}`,
    //   { headers: new HttpHeaders({ 'Content-Type': 'application/json' })});
  }
  updateDeviceInfo(data: DevicesInfoData): Observable<any> {
    const params = {...data, otp: data.otp + this.cryptoService.hashHmacSha512ForContent(data)};
    return this.http.post<any>(`${environment.apiIotUrl}/device/update`, params);
  }

  addMiniCard(data: MiniCardParams): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/add_rmc_new`, data);
  }

  addUpdateDevice(data: AddUpdateDeviceParams): Observable<any> {
    return this.http.post<any>(`${environment.apiSerivceUrl}/Personal/api/Service/AddUpdateDevice`, data);
  }

  addEmbDevice(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/card/emb/add`, params);
  }

  // 調整 Device 頁面使用之 API不從Nodejs拿資料
  // From Nodejs Service.
  // ReadDeviceInfo(dcode, userAcode): Observable<any> {
  //   return this.http.post<any>(`/api/device`, {dcode: dcode, userAcode: userAcode, hashCode: this.cryptoService.hashHmacSha512(dcode)});
  // }

  ReadDeviceInfo(otp, dcodeList, acodeList, allFlag): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/device/read`,
    {otp: otp, DcodeList: dcodeList, AcodeList: acodeList, All: allFlag});
  }

  getBindWifiCards(): Observable<any> {
     return this.http.get<any>(`${environment.rWCCUrl}/about`);
     // return this.http.get<any>(`/wificard/about`);
  }

  getWifiList(): Observable<any> {
    return this.http.get<any>(`${environment.rWCCUrl}/get-wifi`);
    // return this.http.get<any>(`/wificard/get-wifi`);
  }

  getConnectWifi(params): Observable<any> {
    const formData: any = new FormData();
    formData.append('ssid', params.ssid);
    formData.append('password', params.password);
    return this.http.post<any>(`${environment.rWCCUrl}/web-ap-info`, formData);
  }

  getConfigWifiCardResult(): Observable<any> {
    return this.http.get<any>(`${environment.rWCCUrl}/config-result`);
    // return this.http.get<any>(`/wificard/config-result`);
  }

  ReadDeviceShareInfo(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/device/share/read`, params);
  }

  AddDeviceShareInfo(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/device/share/add`, params);
  }

  UpdateDeviceShareInfo(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/device/share/update`, params);
  }

  DeleteDeviceShareInfo(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/device/share/delete`, params);
  }

  // Reset Device
  ResetDevice(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/device/reset`, params);
  }

  // Read Reset Device Log
  ReadResetDeviceLog(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/device/reset/read`, params);
  }

  // Update Device Setting
  UpdateDeviceSetting(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/device/setting/update`, params);
  }

  // 供加卡時無封包上傳則呼叫暫存 Device Name 於 Redis
  addMiniCardWithoutPack(data: MiniCardWithoutPackParams): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/save_rmc_name`, data);
  }

  ReadUPSControlStatus(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/device/upsctrl/read/status`, params);
  }

  ExecuteUPSControl(params): Observable<any> {
    
    params = {...params, otp: params.otp + this.cryptoService.hashHmacSha512ForContent(params)};
    return this.http.post<any>(`${environment.apiIotUrl}/device/upsctrl/execute`, params);
  }
}
